module.exports = __webpack_public_path__ + "img/login.c9ef5288.png";